const STAGE = [
  {
    name: '预习计划',
    startTime: '新教材出来前',
    body: {
      3: [
        {
          week: '第一周',
          detail: [
            {
              days: 1,
              content:
                '听第一章第一节 财务报告目标精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第一章第二节 会计信息质量要求精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第一章第三节 会计要素及其确认与计量原则精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第二章第一节存货的确认和初始计量精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第二章第二节存货的期末计量精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 2,
              content: '复习第一、二章',
            },
          ],
        },
        {
          week: '第二周',
          detail: [
            {
              days: 1,
              content:
                '听第三章第一节  固定资产的确认和初始计量精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第三章第二节  固定资产的后续计量的视频精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第三章第三节  固定资产的处置精讲班的视频,做第三节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第四章第一节 投资性房地产概述精讲班的视频,做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第四章第二节 投资性房地产的确认和初始计量精讲班的视频,做第二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第四章第三节 投资性房地产的后续计量精讲班的视频,做第三节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第四章第四节 投资性房地产的转换和处置精讲班的视频,做第四节的章节练习题',
            },
          ],
        },
        {
          week: '第三周',
          detail: [
            {
              days: 1,
              content:
                '听第六章第一、二节 无形资产的确认和初始计量以及内部研究开发支出的确认和计量精讲班的视频，做第一、二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第六章第三、四节 无形资产的后续计量以及处置精讲班的视频，做第三、四节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第七章第一节 非货币性资产交换的特征和认定精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第七章第二节 非货币性资产交换的确认和计量精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第八章第一节 资产减值概述精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第八章第二节 资产可收回金额的计量和减值损失的确定精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第八章第三节 资产组减值的处理精讲班的视频，做第三节的章节练习题',
            },
          ],
        },
        {
          week: '第四周',
          detail: [
            {
              days: 1,
              content:
                '听第十章第一节 应付职工薪酬精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第十章第二节 借款费用精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第十一章第一节 债务重组方式精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第十一章第二节 债务重组的会计处理精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第十二章第一节 或有事项概述精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第十二章第二节 或有事项的确认和计量精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第十二章第三节 或有事项会计处理原则的应用精讲班的视频，做第三节的章节练习题',
            },
          ],
        },
        {
          week: '第五周',
          detail: [
            {
              days: 1,
              content:
                '听第十四章第一节 政府补助概述精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第十四章第二节 政府补助的会计处理精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第十五章第一节 计税基础与暂时性差异精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第十五章第二节 递延所得税负债和递延所得税资产精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第十五章第三节 所得税费用的确认和计量精讲班的视频，做第三节的章节练习题',
            },
          ],
        },
        {
          week: '第六周',
          detail: [
            {
              days: 2,
              content:
                '听第十六章第一节 外币交易的会计处理精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第十六章第二节 外币财务报表折算精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第十七章第一节 会计政策及其变更精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第十七章第二节 会计估计及其变更精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第十七章第三节 前期差错更正精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 1,
              content: '复习所学内容',
            },
          ],
        },
        {
          week: '第七周',
          detail: [
            {
              days: 1,
              content:
                '听第十八章第一节 资产负债表日后事项概述精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第十八章第二节 资产负债表日后调整事项精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第十八章第三节 资产负债表日后非调整事项精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 4,
              content:
                '听第五章第一节 长期股权投资的范围和初始计量精讲班的视频，做第一节的章节练习题',
            },
          ],
        },
        {
          week: '第八周',
          detail: [
            {
              days: 5,
              content:
                '听第五章第二节 长期股权投资的后续计量精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 2,
              content: '复习 听第五章',
            },
          ],
        },
        {
          week: '第九周',
          detail: [
            {
              days: 1,
              content:
                '听第十九章第一节 财务报告概述精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第十九章第二节 合并财务报告概述精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 4,
              content:
                '听第十九章第三节 合并资产负债表精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第十九章第四节 合并利润表精讲班的视频，做第四节的章节练习题',
            },
          ],
        },
        {
          week: '第十周',
          detail: [
            {
              days: 1,
              content:
                '听第十九章第五节 合并现金流量表精讲班的视频，做第五节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第十九章第六节 合并所有者权益变动表精讲班的视频，做第六节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第十九章第七节 特殊交易在合并财务报表中的会计处理精讲班的视频，做第七节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第十九章第八节 合并财务报表附注精讲班的视频，做第八节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第十九章第九节 合并财务报表综合举例精讲班的视频，做第九节的章节练习题',
            },
            {
              days: 2,
              content: '复习 第十九章',
            },
          ],
        },
        {
          week: '第十一周',
          detail: [
            {
              days: 1,
              content:
                '听第二十章第一节 政府会计概述精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第二十章第二节 政府单位特定业务的核算精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第二十一章第一节 民间非盈利组织会计概述精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第二十一章第二节 民间非盈利组织特定业务的核算精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第二十一章第三节 民间非营利组织的财务会计报告精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 1,
              content: '复习本书',
            },
          ],
        },
      ],
      5: [
        {
          week: '第一周',
          detail: [
            {
              days: 1,
              content:
                '听第一章第一节 企业与企业财务管理精讲班视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第一章第二节 财务管理目标精讲班视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第一章第三节 财务管理环节精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第一章第四节 财务管理体制精讲班的视频，做第四节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第一章第五节 财务管理环境精讲班的视频，做第五节的章节练习题',
            },
            {
              days: 2,
              content: '复习第一章',
            },
          ],
        },
        {
          week: '第二周',
          detail: [
            {
              days: 3,
              content:
                '听第二章第一节 货币时间价值精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 3,
              content:
                '听第二章第二节 风险与收益精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第二章第三节 成本性态分析精讲班的视频，做第三节的章节练习题',
            },
          ],
        },
        {
          week: '第三周',
          detail: [
            {
              days: 1,
              content: '复习第二章',
            },
            {
              days: 1,
              content:
                '听第三章第一节 预算管理概述精讲班视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第三章第二节 预算的编制方法与程序精讲班视频，做第二节的章节练习题',
            },
            {
              days: 2,
              content: '听第三章第三节 预算编制精讲班视频，做第三节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第三章第四节 预算的执行与考核精讲班视频，做第四节的章节练习题',
            },
            {
              days: 1,
              content: '复习第三章',
            },
          ],
        },
        {
          week: '第四周',
          detail: [
            {
              days: 1,
              content:
                '听第四章第一节 筹资管理概述精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第四章第二节 债务筹资精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第四章第三节 股权筹资精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第四章第四节 衍生工具筹资精讲班的视频，做第四节的章节练习题',
            },
            {
              days: 1,
              content: '复习第四章',
            },
            {
              days: 2,
              content:
                '听第五章第一节 资金需要量预测精讲班的视频，做第一节的章节练习题',
            },
          ],
        },
        {
          week: '第五周',
          detail: [
            {
              days: 2,
              content:
                '听第五章第二节 资本成本精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第五章第三节 杠杆效应精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第五章第四节 资本结构精讲班的视频，做第四节的章节练习题',
            },
            {
              days: 1,
              content: '复习第五章',
            },
          ],
        },
        {
          week: '第六周',
          detail: [
            {
              days: 1,
              content:
                '听第六章第一节 投资管理概述精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 3,
              content:
                '听第六章第二节 投资项目财务评价指标精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 3,
              content:
                '听第六章第三节 项目投资管理精讲班的视频，做第三节的章节练习题',
            },
          ],
        },
        {
          week: '第七周',
          detail: [
            {
              days: 2,
              content:
                '听第六章第四节 证券投资管理精讲班的视频，做第四节的章节练习题',
            },
            {
              days: 1,
              content: '复习第六章',
            },
            {
              days: 1,
              content:
                '听第七章第一节 营运资金管理概述精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第七章第二节 现金管理精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content: '复习第七章1-2节',
            },
          ],
        },
        {
          week: '第八周',
          detail: [
            {
              days: 2,
              content:
                '听第七章第三节 应收账款管理精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第七章第四节 存货管理精讲班的视频，做第四节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第七章第五节 流动负债管理精讲班的视频，做第五节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第八章第一节 成本管理概述精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第八章第二节 量本利分析与应用精讲班的视频，做第二节的章节练习题',
            },
          ],
        },
        {
          week: '第九周',
          detail: [
            {
              days: 2,
              content:
                '听第八章第三节 标准成本控制与分析精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第八章第四节 作业成本与责任成本精讲班的视频，做第四节的章节练习题',
            },
            {
              days: 1,
              content: '复习第7-8章',
            },
            {
              days: 1,
              content:
                '听第九章第一节 收入与分配管理概述精讲班的视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第九章第二节 收入管理精讲班的视频，做第二节的章节练习题',
            },
          ],
        },
        {
          week: '第十周',
          detail: [
            {
              days: 3,
              content:
                '听第九章第三节 纳税管理精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第九章第四节 分配管理精讲班的视频，做第四节的章节练习题',
            },
            {
              days: 1,
              content: '复习第九章',
            },
            {
              days: 1,
              content:
                '听第十章第一节 财务分析与评价概述精讲班的视频，做第一节的章节练习题',
            },
          ],
        },
        {
          week: '第十一周',
          detail: [
            {
              days: 3,
              content:
                '听第十章第二节 基本的财务报表分析精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第十章第三节 上市公司财务分析精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第十章第四节 财务评价与考核精讲班的视频，做第四节的章节练习题',
            },
            {
              days: 1,
              content: '复习第十章',
            },
          ],
        },
      ],
      4: [
        {
          week: '第一周',
          detail: [
            {
              days: 1,
              content:
                '听第一章第一节 经济法概述精讲班视频，做第一节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第一章第二节 法律行为与代理精讲班视频，做第二节的章节练习题',
            },
            {
              days: 3,
              content:
                '听第一章第三节 经济仲裁与诉讼精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 1,
              content: '复习第一章',
            },
          ],
        },
        {
          week: '第二周',
          detail: [
            {
              days: 1,
              content:
                '听第二章第一节 公司法律制度概述精讲班视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第二章第二节 公司的登记管理精讲班视频，做第二节的章节练习题',
            },
            {
              days: 4,
              content:
                '听第二章第三节 有限责任公司精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 1,
              content: '复习第二章1-3节',
            },
          ],
        },
        {
          week: '第三周',
          detail: [
            {
              days: 2,
              content:
                '听第二章第四节 股份有限公司精讲班的视频，做第四节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第二章第五节 公司董监高的资格和义务精讲班的视频，做第五节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第二章第六节 公司股票和公司债券精讲班的视频，做第六节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第二章第七节 公司财务、会计精讲班的视频，做第七节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第二章第八节 公司合并、分立、增资、减资精讲班的视频，做第八节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第二章第九节 公司解散和清算精讲班的视频，做第九节的章节练习题',
            },
          ],
        },
        {
          week: '第四周',
          detail: [
            {
              days: 1,
              content:
                '听第二章第十节 违反公司法的法律责任精讲班的视频，做第十节的章节练习题',
            },
            {
              days: 2,
              content: '复习第二章',
            },
            {
              days: 1,
              content:
                '听第三章第一节 个人独资企业法律制度精讲班视频，做第一节的章节练习题',
            },
            {
              days: 3,
              content:
                '听第三章第二节 合伙企业法律制度精讲班的视频，做第二节的章节练习题',
            },
          ],
        },
        {
          week: '第五周',
          detail: [
            {
              days: 1,
              content: '复习第三章',
            },
            {
              days: 6,
              content:
                '听第四章第一节 证券法律制度法律制度精讲班视频，做第一节的章节练习题',
            },
          ],
        },
        {
          week: '第六周',
          detail: [
            {
              days: 3,
              content:
                '听第四章第二节 保险法律制度精讲班的视频，做第二节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第四章第三节 票据法律制度精讲班视频，做第三节的章节练习题',
            },
            {
              days: 2,
              content: '复习第四章',
            },
          ],
        },
        {
          week: '第七周',
          detail: [
            {
              days: 1,
              content:
                '听第五章第一节 合同法律制度概述精讲班视频，做第一节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第五章第二节 合同的订立精讲班视频，做第二节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第五章第三节 合同的效力精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第五章第四节 合同的履行精讲班的视频，做第四节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第五章第五节 合同的担保精讲班的视频，做第五节的章节练习题',
            },
          ],
        },
        {
          week: '第八周',
          detail: [
            {
              days: 1,
              content:
                '听第五章第六节 合同的变更和转让精讲班的视频，做第六节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第五章第七节 合同的权利义务终止精讲班的视频，做第七节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第五章第八节 违约责任精讲班的视频，做第八节的章节练习题',
            },
            {
              days: 3,
              content:
                '听第五章第九节 主要合同精讲班的视频，做第九节的章节练习题',
            },
            {
              days: 1,
              content: '复习第五章',
            },
          ],
        },
        {
          week: '第九周',
          detail: [
            {
              days: 1,
              content:
                '听第六章第一节 增值税法律制度概述概述精讲班视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第六章第二节 增值税的纳税人、增税范围和税率精讲班视频，做第二节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第六章第三节 增值税应纳税额的计算精讲班的视频，做第三节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第六章第四节 增值税的税收优惠精讲班的视频，做第四节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第六章第五节 增值税的征收管理和发票管理精讲班的视频，做第五节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第六章第六节 增值税的出口退（免）税制度精讲班的视频，做第六节的章节练习题',
            },
          ],
        },
        {
          week: '第十周',
          detail: [
            {
              days: 1,
              content: '复习第六章',
            },
            {
              days: 1,
              content:
                '听第七章第一节 企业所得税概述精讲班视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第七章第二节 企业所得税的纳税人、征税范围及税率精讲班视频，做第二节的章节练习题',
            },
            {
              days: 3,
              content:
                '听第七章第3-4节 企业所得税的应纳税所得额、应纳税额精讲班的视频，做第3-4节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第七章第五节 税收优惠精讲班的视频，做第五节的章节练习题',
            },
          ],
        },
        {
          week: '第十一周',
          detail: [
            {
              days: 1,
              content:
                '听第七章第6-8节 企业所得税的源泉扣缴、特别纳税调整、征收管理精讲班的视频，做第6-8节的章节练习题',
            },
            {
              days: 1,
              content: '复习第七章',
            },
            {
              days: 2,
              content: '听第八章第一节 预算法精讲班视频，做第一节的章节练习题',
            },
            {
              days: 1,
              content:
                '听第八章第二节 国有资产管理法律制度精讲班视频，做第二节的章节练习题',
            },
            {
              days: 2,
              content:
                '听第八章第三节 知识产权法律制度精讲班视频，做第三节的章节练习题',
            },
          ],
        },
        {
          week: '第十二周',
          detail: [
            {
              days: 1,
              content:
                '听第八章第四节 政府采购法律制度精讲班的视频，做第四节的章节练习题',
            },
            {
              days: 1,
              content: '复习第八章',
            },
            {
              days: 3,
              content: '复习本书',
            },
          ],
        },
      ],
    },
  },
  {
    name: '精讲班计划',
    startTime: '预计2020年4月开启',
    body: { 1: [], 2: [] },
  },
  {
    name: '习题班计划',
    startTime: '预计2020年6月开启',
    body: { 1: [], 2: [] },
  },
  {
    name: '冲刺班计划',
    startTime: '预计2020年7月开启',
    body: { 1: [], 2: [] },
  },
  { name: '救命稻草计划', startTime: '考前开启', body: { 1: [], 2: [] } },
];

export default STAGE;
